import React from 'react';
import {
  FormGroup,
  ControlLabel,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';


import JobReviewTable from '../componets/JobReviewTable';
import { selectJobId, selectDistrict, selectDepartment } from '../actions';
import { getCurrentJobId, getCurrentDistrictId, getCurrentDepartmentId } from '../selectors';
import { queryGetJobReviewInboxDataGQL } from '../graphql/initialJobStateQuery';


import DepartmentFilter from '../../fields/DepartmentFilter';
import DistrictFilter from '../../fields/DistrictFilter';


const propTypes = exact({
  jobs: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedJobId: PropTypes.number,
  selectJobIdAction: PropTypes.func.isRequired,
  selectDistrictAction: PropTypes.func.isRequired,
  selectDepartmentAction: PropTypes.func.isRequired,
  currentDistrictId: PropTypes.number,
  currentDepartmentId: PropTypes.number,
});


const JobApprovalInbox = (props) => {
  const {
    jobs,
    selectedJobId,
    currentDistrictId,
    currentDepartmentId,
    selectJobIdAction,
    selectDepartmentAction,
    selectDistrictAction,
  } = props;

  return (
    <div>
      <div>
        <FormGroup>
          <ControlLabel className="control-label">
            Field District Filter:
          </ControlLabel>
          <div>
            <DistrictFilter
              name="Field District"
              value={{ id: currentDistrictId }}
              onChange={selectDistrictAction}
              departmentId={currentDepartmentId}
            />
          </div>
        </FormGroup>
        <FormGroup>
          <ControlLabel className="control-label">
            Department Filter:
          </ControlLabel>
          <div>
            <DepartmentFilter
              name="Department"
              value={{ id: currentDepartmentId }}
              onChange={selectDepartmentAction}
              districtId={currentDistrictId}
            />
          </div>
        </FormGroup>
      </div>
      <div className="panel panel-default">
        <div style={{ maxHeight: '64vh', overflowY: 'auto', overflowX: 'hidden' }}>
          <JobReviewTable
            jobs={jobs}
            selectedJobId={selectedJobId}
            selectJobId={selectJobIdAction}
          />
        </div>
      </div>
    </div>
  );
};


JobApprovalInbox.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    selectedJobId: getCurrentJobId(state),
    currentDistrictId: getCurrentDistrictId(state),
    currentDepartmentId: getCurrentDepartmentId(state),
  };
};


const mapDispatchToProps = {
  selectJobIdAction: selectJobId,
  selectDistrictAction: selectDistrict,
  selectDepartmentAction: selectDepartment,
};


const withRedux = connect(mapStateToProps, mapDispatchToProps);


const withSelectFirstJob = lifecycle({
  componentWillMount() {
    const { jobs, selectJobIdAction } = this.props;
    if (jobs.length > 0) {
      selectJobIdAction(jobs[0].id);
    }
  },
});


const enhance = compose(
  withRedux,
  queryGetJobReviewInboxDataGQL,
  withSelectFirstJob,
);


export default enhance(JobApprovalInbox);
